export default function (context, {field, value}) {
    switch (field) {
        default:
            let d = {};
            d[field] = value;
            context.commit('set', d);
    }
}